import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router';
import specialOffer from '../../assets/specialOffer.jpeg';

function PromoSection() {
  return (
    <section className="bg-gradient-to-r from-teal-500 to-green-500 text-white py-20 px-6 relative overflow-hidden">
      {/* Decorative wave pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-full">
          <path fill="#ffffff" fillOpacity="1" d="M0,128L48,144C96,160,192,192,288,197.3C384,203,480,181,576,165.3C672,149,768,139,864,154.7C960,171,1056,213,1152,218.7C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>

      <motion.div 
        className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center relative z-10"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <div className="space-y-6">
          {/* Accent Highlight */}
          <motion.div 
            className="flex items-center space-x-3 mb-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <div className="h-1 w-12 bg-white bg-opacity-50 rounded-full"></div>
            <span className="text-sm uppercase font-semibold">
              Patient-Centered Care
            </span>
          </motion.div>

          <motion.h2 
            className="text-3xl md:text-4xl font-bold leading-tight"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            We Put Our Patients at the Center of Everything We Do
          </motion.h2>
          
          <motion.div 
            className="space-y-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            <p className="text-lg leading-relaxed">
              At Pristine Smile, your comfort, care, and confidence come first. Every decision we make —
              from the technology we invest in to the way we design your treatment plan — is centered around
              your needs, goals, and well-being.
            </p>
            <p className="italic opacity-80">
              We don't just fix teeth. We build relationships. We create trust. And we help you smile brighter every day.
            </p>
          </motion.div>

          {/* CTA Buttons */}
          <motion.div 
            className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            <Link
              to="/schedule-appointment"
              className="w-full sm:w-auto inline-block bg-white text-teal-600 px-6 py-3 rounded-lg shadow-md hover:bg-white/90 transition-all transform hover:-translate-y-1 hover:shadow-xl text-center"
            >
              Book Your Appointment
            </Link>
            <a
              href="tel:8401749379"
              className="w-full sm:w-auto inline-block border-2 border-white text-white px-6 py-3 rounded-lg hover:bg-white/20 transition-all text-center"
            >
              Call Us: 8401749379
            </a>
          </motion.div>
        </div>

        {/* Right Poster */}
        <motion.div 
          className="w-full max-w-md mx-auto group"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          <div className="relative">
            {/* Decorative Border */}
            <div className="absolute -inset-2 bg-white/20 rounded-xl blur-sm group-hover:opacity-75 transition duration-500 opacity-0"></div>
            
            <img
              src={specialOffer}
              alt="Special Offer"
              className="relative rounded-xl shadow-xl w-full object-cover transform transition-all duration-500 group-hover:scale-105 group-hover:rotate-1"
            />
            
            {/* Overlay Offer Badge */}
            <div className="absolute top-4 right-4 bg-white text-teal-600 px-4 py-2 rounded-full text-sm font-bold shadow-lg">
              10% OFF
            </div>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}

export default PromoSection;